import { render } from "./LicenseAgreement.vue?vue&type=template&id=055784e9&ts=true"
import script from "./LicenseAgreement.vue?vue&type=script&lang=ts"
export * from "./LicenseAgreement.vue?vue&type=script&lang=ts"

import "./LicenseAgreement.vue?vue&type=style&index=0&id=055784e9&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__